import React, { useState, useEffect, useRef } from 'react'
import {
    Box, Tooltip, TextField
} from "@mui/material";
import PricingCopyMenu from './PricingCopyMenu'

const MaxInput = ({ day, season, seasonEditCopyRef, isReadOnlyMode, manageSeasonChangeFunc, discardCount, globalErrorMsg, disableDownCopy, disableRightCopy, copyInputCount, registerRef, onNavigate }) => {
    const { threshold_min, threshold_max } = seasonEditCopyRef.current.base_room_type;

    const inputRef = useRef(null);
    const [inputErrorMsg, setInputErrorMsg] = useState(false);
    const [isBaseRoomTypeChanged, setIsBaseRoomTypeChanged] = useState(season.isBaseRoomTypeChanged);

    const handleInputBlur = (event) => {
        let min = threshold_min[day];
        let max = event.target.value.trim();

        // remove decimal if any
        if (max.includes('.')) {
            max = max.split('.')[0];
            event.target.value = max;
        }

        // if max has negative sign then remove it
        if (max.includes('-')) {
            max = 0;
            max = Number(max);
            event.target.value = max;
            seasonEditCopyRef.current.base_room_type.threshold_max[day] = max;
            manageSeasonChangeFunc({ action: 'inputChange', season: seasonEditCopyRef.current });
            return;
        }

        // if max is blank
        if (max === '') {
            setInputErrorMsg('This field is required.');
            seasonEditCopyRef.current.base_room_type.threshold_max[day] = null;
            manageSeasonChangeFunc({ action: 'inputChange', season: seasonEditCopyRef.current });
            return;
        }
        setIsBaseRoomTypeChanged(false);
        // if min is blank then min can be any positive number
        if (!min && min !== 0) {
            max = Number(max);
            setInputErrorMsg(false);
            seasonEditCopyRef.current.base_room_type.threshold_max[day] = max;
            manageSeasonChangeFunc({ action: 'inputChange', season: seasonEditCopyRef.current });
            return;
        }

        // if max is less than min
        min = Number(min);
        max = Number(max);
        if (max < min) {
            setInputErrorMsg('Ceiling cannot be lesser than floor.');
            seasonEditCopyRef.current.base_room_type.threshold_max[day] = max;
            manageSeasonChangeFunc({ action: 'inputChange', season: seasonEditCopyRef.current });
            return;
        }

        setInputErrorMsg(false);
        seasonEditCopyRef.current.base_room_type.threshold_max[day] = max;
        manageSeasonChangeFunc({ action: 'inputChange', season: seasonEditCopyRef.current });

    }

    useEffect(() => {
        setInputErrorMsg(false);
        inputRef.current.value = season.base_room_type.threshold_max[day];
    }, [discardCount])

    useEffect(() => {
        if (seasonEditCopyRef.current.base_room_type.threshold_min[day] && seasonEditCopyRef.current.base_room_type.threshold_max[day]) {
            let min = seasonEditCopyRef.current.base_room_type.threshold_min[day];
            let max = seasonEditCopyRef.current.base_room_type.threshold_max[day];
            if (max < min) {
                setInputErrorMsg('Ceiling cannot be lesser than floor.');
            }
            else {
                setInputErrorMsg(false);
            }
        }
    }, [globalErrorMsg.length]);

    const handleCopyRight = () => {
        setIsBaseRoomTypeChanged(false);
        const currentValue = seasonEditCopyRef.current.base_room_type.threshold_max[day];

        const dayKeys = Object.keys(seasonEditCopyRef.current.base_room_type.threshold_max);
        const currentIndex = dayKeys.indexOf(day);
        if (currentIndex === -1) return;

        // Copy value to the right-side inputs
        for (let i = currentIndex + 1; i < dayKeys.length; i++) {
            const nextDay = dayKeys[i];
            seasonEditCopyRef.current.base_room_type.threshold_max[nextDay] = currentValue;

            // If copied max is less than min, replace with min instead
            // const minValue = seasonEditCopyRef.current.base_room_type.threshold_min[nextDay];
            // if (minValue !== null && minValue !== undefined && currentValue < minValue) {
            //     seasonEditCopyRef.current.base_room_type.threshold_max[nextDay] = minValue;
            // } else {
            //     seasonEditCopyRef.current.base_room_type.threshold_max[nextDay] = currentValue;
            // }
        }

        manageSeasonChangeFunc({
            action: 'copyInput',
            season: seasonEditCopyRef.current
        });
        //console.log("seasonEditCopyRef.current", seasonEditCopyRef.current)
    };

    useEffect(() => {
        inputRef.current.value = seasonEditCopyRef.current.base_room_type.threshold_max[day];

        // clear the error on copied inputs if value is validated
        const minValue = seasonEditCopyRef.current.base_room_type.threshold_min[day];
        const maxValue = seasonEditCopyRef.current.base_room_type.threshold_max[day];

        if (maxValue !== null && maxValue > minValue) {
            setInputErrorMsg(false);
            setIsBaseRoomTypeChanged(false);

        }
    }, [copyInputCount]);

    // Register on every render
    registerRef("max", day, inputRef);

    const handleArrowKeyNavigation = (e) => {
        const navKeys = ["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"];
        if (!navKeys.includes(e.key)) return;

        e.preventDefault();
        const direction = e.key.replace("Arrow", "").toLowerCase();
        onNavigate(direction, day, "max");
    };



    return (
        <Box className="grid-col" >
            <Tooltip
                arrow
                title={inputErrorMsg}
                placement="top"
                slotProps={{
                    tooltip: {
                        sx: {
                            maxWidth: 350,
                        },
                    },
                }}
            >
                <TextField
                    type="number"
                    inputRef={inputRef}
                    className={`custon-textfield 
                        ${inputErrorMsg ? 'error' : ''}
                        ${threshold_max[day] === null && !season.id.includes('new_') ? 'empty_field' : ''} 
                    `}
                    size="small"
                    fullWidth
                    margin="dense"
                    disabled={isReadOnlyMode}
                    defaultValue={threshold_max[day]}
                    onFocus={(e) => e.target.select()}
                    onBlur={(event) => { handleInputBlur(event) }}
                    onKeyDown={handleArrowKeyNavigation}
                    autoComplete="off"
                />
                {!isReadOnlyMode && threshold_max[day] !== null && threshold_max[day] !== undefined && (
                    <PricingCopyMenu
                        disableDownCopy={disableDownCopy}
                        disableRightCopy={disableRightCopy}
                        onCopyRight={handleCopyRight}
                    />
                )}
            </Tooltip>
        </Box>
    )
}

export default MaxInput